module.exports = "<div class=\"external\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-md-6 col-md-offset-3\">\n                <h2>Invitation Accepted</h2>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6 col-md-offset-3 hspace-10\">\n                <p>Welcome to the <b><%- groupName %></b> team! Please <a href=\"#/\">sign in</a> to access this team's Dashboards and Installations.</p>\n            </div>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/invitationAccepted.html
// module id = 628
// module chunks = 7